<template>
    <div class="sorts">
        <sort :sortType="sortType" :chagneSortType="chagneSortType" :list="sortList" />
    </div>
    <div class="split-line"></div>
    <div class="item" v-for="item in list" :key="item.id">        
        <div class="title">
            <router-link :to="{path:'/essay_detail',query:{id:item.id,type:1}}" target="_blank">{{item.title}}</router-link>
        </div>
        <div class="author">
            {{item.authors?item.authors.join(' ')+" -" :''}} 《{{item.journalNameZH}}》 - {{item.pubYear}}年第{{item.period}}期发表
        </div>
        <router-link :to="{path:'/essay_detail',query:{id:item.id,type:1}}" target="_blank">
        <div class="desc">{{item.summary}}</div>
        </router-link>
        <div class="keywords">
            <div class="count">
                <span class="browseCount"><i class="iconfont icon-liulan"></i>&nbsp;{{numWan(item.browseQua)}}&nbsp;</span>
                <span class="collectCount"><i class="iconfont icon-shoucang"></i>&nbsp;{{numWan(item.collectQua)}}&nbsp;</span>
                <span class="recCount"><i class="iconfont icon-dianzan_kuai"></i>&nbsp;{{numWan(item.praiseQua)}}&nbsp;</span>
            </div>
            <!-- <a-tag v-for="i in item.topicsName" :key="i">
                {{i}}
            </a-tag> -->
             <a-tag v-for="i in item.topicList" :key="i.topicId">
                  <!-- <router-link
                    :to="{ path: '/collection_detail', query: { id: i.topicId } }"
                    target="_blank"
                  > -->
                    {{ i.topicName }}
                  <!-- </router-link> -->
                </a-tag> 
            <div class="clearx"></div>
        </div>
    </div>
    <div class="page">
        <a-pagination :current="currentPage" show-quick-jumper :total="totals" @change="changePage" />
    </div>
</template>

<script>
import { computed, defineComponent, reactive, toRefs, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";
import Sort from "../../components/Sort.vue";
import Http from '../../until/http';
import { numWan } from "../../until/tools";

export default defineComponent({
  components: { Sort },
    setup() {
        const state = reactive({
            list:[],
            totals:0,
            sortList:[{value:0,title:'最近更新'},{value:1,title:'浏览最多'}]
        });
        const route = useRoute();
        const router = useRouter();
        const currentPage = computed(()=>{
            let page = route.query.page;
            if(page) {
                return parseInt(page);
            }
            return 1;
        });
        const sortType = computed(()=>{
            let type = route.query.sort;
            if(type) {
                return parseInt(type);
            }
            return 0;
        });

        watchEffect(()=>{
            Http.getEssayRec({pageNum:currentPage.value,sortType:sortType.value}).then(res=>{
                if(res) {
                    Object.assign(state,{
                        list:res.articles,
                        totals:res.condition.totalColumns
                    })
                    window.scrollTo(0,0);
                }
            })
        })
        
        const changePage = (page)=>{
            router.push({path:'/essay_rec',query:{page:page,sort:sortType.value}});
        }

        const chagneSortType = (e)=>{
            router.push({path:'/essay_rec',query:{sort:e}});
        }

        return {
            ...toRefs(state),
            currentPage,
            sortType,
            changePage,
            chagneSortType,            
            numWan
        }
    }
})
</script>

<style lang="scss" scoped>
.ant-tag{
    background: #fff;
}
</style>